// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"44":"p__detail__index","89":"p__bulletin__index","717":"layouts__index"}[chunkId] + "." + {"44":"b767fa67","89":"ead64df3","717":"118460ca"}[chunkId] + ".chunk.css";
};